import _ from "lodash";

const subjectMapper = {
  /**
   * Map array of subject objects
   * @param {Array} subjects
   * @return {Array}
   */
  mapSubjects: function(subjects) {
    return subjects.map(subject => {
      return this.mapSubject(subject);
    });
  },

  /**
   * Map subject object
   * @param {Object} subject
   * @return {Object}
   */
  mapSubject: function(subject) {
    return _.mapKeys(subject, (value, key) => _.camelCase(key));
  },

  /**
   * Map array of subject objects to options for select component
   * @param {Array} subjects
   * @return {Array}
   */
  mapSubjectsAsOptions(subjects) {
    let options = [];
    subjects.forEach(subject => {
      let option = {};
      option.value = subject.id;
      option.court_case_number = subject.court_case_number;
      option.text = subject.court_name;
      option.court_name = subject.court_name;
      option.internal_subject_number = subject.internal_subject_number;
      options.push(option);
    });
    return options;
  }
};

export default subjectMapper;
